import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../../constants/languages";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import FileUploader from "react-firebase-file-uploader";
import Grid from "@material-ui/core/Grid";
import UploadIcon from "@material-ui/icons/CloudUpload";
import CircularProgress from "@material-ui/core/CircularProgress";
import { validateFileSize } from "../../../util/uploadErrors";

export default class DiaPhotoDialog extends React.Component {
  render() {
    const maxFileSizeMb = this.props.maxFileSizeMb || 1;
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {languages.present.addPicture}
        </DialogTitle>
        <form>
          <DialogContent style={{ width: 400, maxWidth: "97%", paddingTop: 0 }}>
            <DialogContentText />
            <TextField
              fullWidth
              name="title"
              value={this.props.title}
              onChange={this.props.handleTitleChange}
              label={languages.present.title2}
            />
            <br />
            <br />
            <div>
              <Typography variant="caption">
                {this.props.pictureDescriptionText ||
                  languages.present.pictureDescription}
              </Typography>
              {this.props.errorMessagePhoto && (
                <div>
                  <Typography style={{ color: "red" }}>
                    {this.props.errorMessagePhoto}
                  </Typography>
                </div>
              )}
              {(this.props.tournament || {}).ia && this.props.warningSVG && (
                <div>
                  <Typography variant="caption" style={{ color: "red" }}>
                    {languages.present.warningSVG}
                  </Typography>
                </div>
              )}
              <Grid
                container
                spacing={1}
                alignItems="flex-start"
                style={{ marginBottom: 15, marginTop: 5 }}
              >
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Paper style={{ width: "100%" }}>
                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                        height: 250,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {this.props.isUploading ? (
                        <CircularProgress size={28} />
                      ) : this.props.photoURL ? (
                        <img
                          style={{
                            maxWidth: "100%",
                            maxHeight: 250,
                            margin: "auto",
                            verticalAlign: "middle",
                          }}
                          src={this.props.photoURL}
                          alt=""
                        />
                      ) : (
                        <Typography
                          style={{
                            color: "gray",
                            display: "inline-block",
                            width: "100%",
                            textAlign: "center",
                          }}
                        >
                          {languages.present.picture}
                        </Typography>
                      )}
                    </div>
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <FileUploader
                    id="upload-photo"
                    style={{ display: "none" }}
                    accept="image/*"
                    name="photoUpload"
                    randomizeFilename
                    storageRef={this.props.storageRef}
                    beforeUploadStart={(file) => {
                      validateFileSize(file, maxFileSizeMb);
                    }}
                    onUploadStart={this.props.handleUploadStart}
                    onUploadError={(error) => {
                      this.props.handleUploadError(error);
                    }}
                    onUploadSuccess={(fileName) => {
                      this.props.handleUploadSuccess(fileName);
                    }}
                    onProgress={this.props.handleProgress}
                  />
                  <label
                    htmlFor={this.props.allowedToUpload ? "upload-photo" : ""}
                  >
                    <Button
                      fullWidth
                      variant="outlined"
                      component="span"
                      color="primary"
                      onClick={
                        !this.props.allowedToUpload
                          ? this.props.toggleUpgradeDialog
                          : () => {}
                      }
                    >
                      {languages.tournament.upload}
                      <UploadIcon style={{ marginLeft: 5 }} />
                    </Button>
                  </label>
                </Grid>
              </Grid>
            </div>
          </DialogContent>
          {this.props.errorMessage && (
            <DialogActions>
              <div>
                <Typography style={{ color: "red" }}>
                  {this.props.errorMessage}
                </Typography>
              </div>
            </DialogActions>
          )}
          <DialogActions>
            <Button onClick={this.props.toggleDialog} color="primary">
              {languages.general.cancel}
            </Button>
            <Button
              disabled={
                !this.props.photoURL ||
                (this.props.titleRequired && !this.props.title)
              }
              onClick={this.props.handleSubmit}
              variant="contained"
              color="primary"
              type="submit"
            >
              {languages.general.save}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}
